import React from "react";
import { connect } from "react-redux";
import { Service } from "../components/Service";
import Loading from "../components/Loading";
import { loadServices } from "../actions/serviceActions";
import { call } from "../actions/sipActions";

import "./Services.css";

class Services extends React.Component {
  componentDidMount() {
    this.props.loadServices();
  }

  render() {
    if (this.props.loading) {
      return <Loading />;
    }

    return (
      <div className={"services-container"}>
        <h1 id="h1id">{this.props.text("menu.servicesHeadline")}</h1>
        <div className="row services">
          {this.props.services.map((item, index) => (
            <Service
              text={this.props.text}
              service={item}
              key={item.id}
              onClick={() => {
                this.props.call(item.sipaddress);
              }}
            />
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    services: state.service.services,
    loading: state.service.loading,
    text: state.config.text,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadServices: () => {
      return dispatch(loadServices());
    },
    call: callTo => {
      return dispatch(call(callTo));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Services);






// WEBPACK FOOTER //
// ./src/containers/Services.js